var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.languages.length > 1
    ? _c(
        "div",
        {
          staticClass: "i18n_group"
        },
        [
          _vm._l(_vm.languages, function(language) {
            return _vm.selectedLanguage !== null &&
              language.id === _vm.selectedLanguage.id
              ? _c(
                  "div",
                  {
                    staticClass: "i18n",
                    attrs: {
                      "data-lang": language.name,
                      "data-icon":
                        "url(" +
                        _vm.assetsURL +
                        "images/languages/" +
                        language.picture +
                        ")"
                    }
                  },
                  [
                    _vm.type === "text"
                      ? _c(
                          "input",
                          _vm._g(
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.values[_vm.selectedLanguage.id],
                                    expression: "values[selectedLanguage.id]"
                                  }
                                ],
                                ref: "inputfield",
                                refInFor: true,
                                attrs: {
                                  type: "text",
                                  name: _vm.nameOfInput(language.id),
                                  required:
                                    _vm.required &&
                                    _vm.defaultLanguage === language.id
                                },
                                domProps: {
                                  value: _vm.values[_vm.selectedLanguage.id]
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }

                                    _vm.$set(
                                      _vm.values,
                                      _vm.selectedLanguage.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              },
                              "input",
                              _vm.$attrs,
                              false
                            ),
                            _vm.$listeners
                          )
                        )
                      : _vm.type === "textarea"
                      ? _c(
                          "textarea",
                          _vm._g(
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.values[language.id],
                                    expression: "values[language.id]"
                                  }
                                ],
                                ref: "inputfield",
                                refInFor: true,
                                attrs: {
                                  name: _vm.nameOfInput(language.id),
                                  required:
                                    _vm.required &&
                                    _vm.defaultLanguage === language.id
                                },
                                domProps: {
                                  value: _vm.values[language.id]
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }

                                    _vm.$set(
                                      _vm.values,
                                      language.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              },
                              "textarea",
                              _vm.$attrs,
                              false
                            ),
                            _vm.$listeners
                          ),
                          [_vm._v(_vm._s(_vm.values[language.id]))]
                        )
                      : _vm.type === "wysiwyg" && !_vm.wysiwyg_disabled
                      ? _c(
                          "studip-wysiwyg",
                          _vm._g(
                            _vm._b(
                              {
                                ref: "inputfield",
                                refInFor: true,
                                attrs: {
                                  name: _vm.nameOfInput(language.id),
                                  required:
                                    _vm.required &&
                                    _vm.defaultLanguage === language.id
                                },
                                model: {
                                  value: _vm.values[_vm.selectedLanguage.id],
                                  callback: function callback($$v) {
                                    _vm.$set(
                                      _vm.values,
                                      _vm.selectedLanguage.id,
                                      $$v
                                    )
                                  },
                                  expression: "values[selectedLanguage.id]"
                                }
                              },
                              "studip-wysiwyg",
                              _vm.$attrs,
                              false
                            ),
                            _vm.$listeners
                          )
                        )
                      : _c(
                          "textarea-with-toolbar",
                          _vm._g(
                            _vm._b(
                              {
                                ref: "inputfield",
                                refInFor: true,
                                attrs: {
                                  name: _vm.nameOfInput(language.id),
                                  required:
                                    _vm.required &&
                                    _vm.defaultLanguage === language.id
                                },
                                model: {
                                  value: _vm.values[_vm.selectedLanguage.id],
                                  callback: function callback($$v) {
                                    _vm.$set(
                                      _vm.values,
                                      _vm.selectedLanguage.id,
                                      $$v
                                    )
                                  },
                                  expression: "values[selectedLanguage.id]"
                                }
                              },
                              "textarea-with-toolbar",
                              _vm.$attrs,
                              false
                            ),
                            _vm.$listeners
                          )
                        )
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm._l(_vm.languages, function(language) {
            return _vm.selectedLanguage !== null &&
              language.id !== _vm.selectedLanguage.id
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.values[language.id],
                      expression: "values[language.id]"
                    }
                  ],
                  attrs: {
                    type: "hidden",
                    required:
                      _vm.required && _vm.defaultLanguage === language.id,
                    name: _vm.nameOfInput(language.id)
                  },
                  domProps: {
                    value: _vm.values[language.id]
                  },
                  on: {
                    input: function input($event) {
                      if ($event.target.composing) {
                        return
                      }

                      _vm.$set(_vm.values, language.id, $event.target.value)
                    }
                  }
                })
              : _vm._e()
          }),
          _vm._v(" "),
          _c(
            "select",
            {
              staticClass: "i18n",
              style:
                "background-image: url(" +
                _vm.assetsURL +
                "images/languages/" +
                _vm.selectedLanguage.picture +
                ")",
              attrs: {
                tabindex: "0",
                "aria-label": _vm.$gettext("Sprache des Textfeldes auswählen.")
              },
              on: {
                change: _vm.selectLanguage
              }
            },
            _vm._l(_vm.languages, function(language) {
              return _c(
                "option",
                {
                  domProps: {
                    value: language.id
                  }
                },
                [_vm._v(_vm._s(language.name))]
              )
            }),
            0
          )
        ],
        2
      )
    : _c(
        "div",
        [
          _vm.type === "text"
            ? _c(
                "input",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.values[_vm.selectedLanguage.id],
                          expression: "values[selectedLanguage.id]"
                        }
                      ],
                      ref: "inputfield",
                      attrs: {
                        type: "text",
                        name: _vm.name,
                        required: _vm.required
                      },
                      domProps: {
                        value: _vm.values[_vm.selectedLanguage.id]
                      },
                      on: {
                        input: function input($event) {
                          if ($event.target.composing) {
                            return
                          }

                          _vm.$set(
                            _vm.values,
                            _vm.selectedLanguage.id,
                            $event.target.value
                          )
                        }
                      }
                    },
                    "input",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "textarea"
            ? _c(
                "textarea",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.values[_vm.selectedLanguage.id],
                          expression: "values[selectedLanguage.id]"
                        }
                      ],
                      ref: "inputfield",
                      attrs: {
                        name: _vm.name,
                        required: _vm.required
                      },
                      domProps: {
                        value: _vm.values[_vm.selectedLanguage.id]
                      },
                      on: {
                        input: function input($event) {
                          if ($event.target.composing) {
                            return
                          }

                          _vm.$set(
                            _vm.values,
                            _vm.selectedLanguage.id,
                            $event.target.value
                          )
                        }
                      }
                    },
                    "textarea",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "wysiwyg" && !_vm.wysiwyg_disabled
            ? _c(
                "studip-wysiwyg",
                _vm._g(
                  _vm._b(
                    {
                      ref: "inputfield",
                      attrs: {
                        name: _vm.name,
                        required: _vm.required
                      },
                      model: {
                        value: _vm.values[_vm.selectedLanguage.id],
                        callback: function callback($$v) {
                          _vm.$set(_vm.values, _vm.selectedLanguage.id, $$v)
                        },
                        expression: "values[selectedLanguage.id]"
                      }
                    },
                    "studip-wysiwyg",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _c(
                "textarea-with-toolbar",
                _vm._g(
                  _vm._b(
                    {
                      ref: "inputfield",
                      attrs: {
                        name: _vm.name,
                        required: _vm.required
                      },
                      model: {
                        value: _vm.values[_vm.selectedLanguage.id],
                        callback: function callback($$v) {
                          _vm.$set(_vm.values, _vm.selectedLanguage.id, $$v)
                        },
                        expression: "values[selectedLanguage.id]"
                      }
                    },
                    "textarea-with-toolbar",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }